export const emptyStateOptions = [
  {
    filterState: 'open',
    emptyStateTitle: 'No open tickets',
    emptyStateMessage: 'Need help with a problem? Open a ticket below.',
    showSubmitTicketButton: true,
  },
  {
    filterState: 'closed',
    emptyStateTitle: 'No closed tickets',
    emptyStateMessage: '',
    showSubmitTicketButton: false,
  },
  {
    filterState: 'my_open',
    emptyStateTitle: 'You are not the case contact for any open cases.',
    emptyStateMessage: '',
    showSubmitTicketButton: false,
  },
  {
    filterState: 'all',
    emptyStateTitle: 'No existing tickets',
    emptyStateMessage: 'Need help with a problem? Open a ticket below.',
    showSubmitTicketButton: true,
  },
  {
    filterState: 'no_restaurant_assigned',
    emptyStateTitle: 'You have not been assigned to your restaurant yet.',
    emptyStateMessage:
      'Once you are assigned to your restaurant, you will be able to see your restaurant’s tickets.',
    showSubmitTicketButton: false,
  },
  {
    filterState: 'noResultsFound',
    emptyStateTitle: 'No Results Found',
    emptyStateMessage: 'Try a different name or spelling.',
    showSubmitTicketButton: false,
  },
  {
    filterState: 'noFormsFound',
    emptyStateTitle: 'No Ticket Types',
    emptyStateMessage: 'Try a different name or spelling.',
    showSubmitTicketButton: false,
    icon: 'search',
  },
  {
    filterState: 'no_upcoming_appointments',
    emptyStateTitle: 'No upcoming appointments',
    showSubmitTicketButton: false,
    icon: 'calendar',
  },
  {
    filterState: 'no_past_appointments',
    emptyStateTitle: 'No Past Appointments',
    showSubmitTicketButton: false,
    icon: 'calendar',
  },
  {
    filterState: 'noRecentEquipment',
    emptyStateTitle: 'Search All Equipment',
    showSubmitTicketButton: false,
    icon: 'search',
  },
  {
    filterState: 'page_not_found',
    emptyStateTitle: 'Page Not Found',
    emptyStateMessage:
      "We can't find the page you are looking for.\nThe link you followed may be broken, or the page may have been removed.",
    showSubmitTicketButton: true,
    icon: 'alert_octagon',
  },
  {
    filterState: 'noResultsFoundEquipment',
    emptyStateTitle: 'No Results Found',
    emptyStateMessage:
      'Try searching a different item name, type, manufacturer, serial number, or asset tag number.',
    showSubmitTicketButton: true,
    icon: 'search',
  },
  {
    filterState: 'equipmentNotFound',
    emptyStateTitle: 'Equipment Not Found',
    emptyStateMessage:
      'We did not find that piece of equipment, or the URL is incorrect.\nTry searching on the Equipment page with the serial number or asset tag.',
    showSubmitTicketButton: true,
    icon: 'wrench',
  },
  {
    filterState: 'noCurrentEquipmentFound',
    emptyStateTitle: 'No Current Equipment Found',
    emptyStateMessage:
      'We did not find any current equipment for this Restaurant.',
    showSubmitTicketButton: false,
    icon: 'wrench',
  },
  {
    filterState: 'noRestaurantEquipmentFound',
    emptyStateTitle: 'No Restaurant Equipment Found',
    emptyStateMessage:
      'We did not find any current equipment for this Restaurant.',
    showSubmitTicketButton: false,
    icon: 'wrench',
  },
  {
    filterState: 'noTechnologyEquipmentFound',
    emptyStateTitle: 'No Technology Equipment Found',
    emptyStateMessage:
      'We did not find any current equipment for this Restaurant.',
    showSubmitTicketButton: false,
    icon: 'wrench',
  },
  {
    filterState: 'facilitiesEquipmentSearch',
    emptyStateTitle:
      "It looks like you're searching for a facilities item. These are things like\nshelving, tiling, doors, menu boards.",
    emptyStateMessage: '',
    showSubmitTicketButton: true,
    icon: 'building_store',
    boldWord: 'facilities',
  },
  {
    filterState: 'noResultsFoundTickets',
    emptyStateTitle: 'No Results Found',
    emptyStateMessage: `Try keywords in your ticket's description or comments. You can also search by ticket number.`,
    showSubmitTicketButton: false,
    icon: 'search',
  },
  {
    filterState: 'noRecentTickets',
    emptyStateTitle: 'Search all tickets',
    showSubmitTicketButton: false,
    icon: 'search',
  },
];
